import { render, staticRenderFns } from "./AccreditationDetailsCard.vue?vue&type=template&id=32e032fe&scoped=true"
import script from "./AccreditationDetailsCard.vue?vue&type=script&lang=js"
export * from "./AccreditationDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./AccreditationDetailsCard.vue?vue&type=style&index=0&id=32e032fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e032fe",
  null
  
)

export default component.exports